


<div fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="10px" fxFlexFill>


    <div fxFlex="initial" class="logo">
        <img src="https://mysqlvm.blob.core.windows.net/aclfiles/acl-logo-short.png" style="height: 50px;" />
        <div class="app-title">ACL SCOREBOARD</div>
    </div>


    <div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="center center" fxLayoutGap="15px">

        <div fxFlex="initial">
            <button type="button" class="action-button-square" [routerLink]="['/director-landing-page']">DIRECTORS</button>
        </div>        

        <div fxFlex="initial">
            <button type="button" class="action-button-square" (click)="onScoreTracker('practice')">SIDE GAMES</button>
        </div>

    </div>    


    <!-- <div fxFlex="initial">
        <button type="button" class="action-button button-width button-red" (click)="addToHomescreenIOS()">ADD TO HOME SCREEN IOS</button>
    </div>  

    <div fxFlex="initial">
        <button type="button" class="action-button button-width button-red" (click)="addToHomescreen()">ADD TO HOME SCREEN</button>
    </div>     
     -->

    <div fxLayout="row" *ngIf="defferedPromptAvailable || showIOSOnlyInstallButton">

        <div fxFlex="initial" *ngIf="defferedPromptAvailable">
            <button type="button" class="action-button button-width button-red" (click)="addToHomescreen()">ADD TO HOME SCREEN</button>
        </div>   

        <div fxFlex="initial" *ngIf="showIOSOnlyInstallButton">
            <button type="button" class="action-button button-width button-red" (click)="addToHomescreenIOS()">ADD TO HOME SCREEN IOS</button>
        </div>  

    </div>  


    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="15px">

        <div fxFlex="initial">
            <button type="button" class="check-for-udpate-button" (click)="checkForUpdates()">CHECK FOR UPDATES</button>
        </div>       

    </div>    


    <div>
        <div class="version-txt">
            version: {{ version }} 
        </div> 
    </div>

</div>






